import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=51639253&"
import script from "./CompanyHome.vue?vue&type=script&lang=js&"
export * from "./CompanyHome.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHome.vue?vue&type=style&index=0&id=51639253&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports